<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="300px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        color="blue darken-1"
        dark
        text
        v-bind="attrs"
        v-on="on"
        >
        <v-icon left>mdi-account-group-outline</v-icon>
          <v-badge color="blue" :content="roles.length ? roles.length : '-'" :offset-x="-3" :offset-y="7">
            Rollendirme
          </v-badge>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="font-weight-regular">Rol Tanımla</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
            <div :key="group" v-for="(userRole, group) in userRoles">
                <h1 class="text-body-1 black--text mt-5">{{group}}</h1>
                <v-checkbox
                color="green"
                class="mt-0"
                :key="key" v-for="(role, key) in userRole"
                v-model="roles"
                @change="valueEmit"
                :value="role.roleid"
                :label="role.rolename"
                hide-details
                ></v-checkbox>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Gizle
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'SelectRoles',
    props: {
        value: {
            required: false,
            default: []
        }
    },
    data () {
      return {
        roles: [],
        dialog: false,
      }
    },
    computed: {
        ...mapState({
            userRoles: state => state.User.UserRoles.rolesList
        }),
        selectedCount() {

        }
    },
    methods: {
        valueEmit(value) {
            this.$emit('selectedRoles', value);
        }
    },
    created() {
        this.$store.dispatch('User/UserRoles/getRolesList').then(() => {
          if (this.value !== '') this.roles = this.value
        });
    }
}
</script>